import React from 'react';
import onClickOutside, { OnClickOutProps } from 'react-onclickoutside';
import classNames from 'classnames';
import styles from './dropdown.styl';
import pointerIcon from '!!url-loader!./img/arrow.png';

export interface DropdownProps {
  open: boolean;
  onClose: () => void;
}

export type DropdownPropsPropsWithClickOutProps = OnClickOutProps<DropdownProps>;

class DropdownBase extends React.Component<DropdownPropsPropsWithClickOutProps> {
  public handleClickOutside = () => {
    const { onClose } = this.props;
    onClose();
  };
  render() {
    const { children, open } = this.props;
    if (!open) {
      return null;
    }
    return (
      <div className={classNames(styles.dropdown)}>
        <div className={classNames(styles.dropdownContent)}>
          <img className={classNames(styles.pointer)} src={pointerIcon} />
          {children}
        </div>
      </div>
    );
  }
}

export const Dropdown = onClickOutside(DropdownBase);
